import { Option } from '@bucketplace/commerce-admin-ui';

/** 상품카드 뱃지 컬러 */
export const BADGE_COLOR_OPTIONS: Option<string>[] = [
  { text: 'Soft blue', value: '#6391E6' },
  { text: 'Strong cyan', value: '#009FCE' },
  { text: 'Dark gray', value: '#2F3438' },
  { text: 'Soft red', value: '#F05656' },
];
